/**
 * Tour steps for the TopNavbar.
 *
 * @param {Function} t - The i18next translation function from `useTranslation()`.
 * @returns {import('react-joyride').Step[]}
 */
export const getTopNavbarSteps = (t) => [
    {
        target: '[data-tour="tnb-bug-report"]',
        title: t('tour.topNavbar.step-bug-title'),
        content: t('tour.topNavbar.step-bug-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="tnb-profile-avatar"]',
        title: t('tour.topNavbar.step-profile-title'),
        content: t('tour.topNavbar.step-profile-content'),
        disableBeacon: true,
    },
];
